import api from './api';

export default {

  get(placa) {
    return api.get(`/placas/${placa}`);
  },

}
